import { ReactNode } from 'react';

import classNames from 'classnames';

import { EmptyIcon } from 'assets/icons';
import { Button, ButtonProps, Gutter } from 'components/ui/general';
import { EmptySelectors } from 'consts/cypress';
import { capitalizeFirstLetter } from 'utils';

import styles from './Empty.module.scss';

export type EmptyProps = {
  title: ReactNode;
  message?: string;
  className?: string;
  button?: ButtonProps;
  icon?: ReactNode;
};

export const Empty = ({
  title,
  message,
  className,
  button,
  icon,
}: EmptyProps) => {
  return (
    <div
      className={classNames(styles.root, className)}
      data-cy={EmptySelectors.Root}
    >
      <div className={styles.inner}>
        <Gutter gutter={{ bottom: 2 }}>
          <Gutter.Item>
            <Gutter gutter={{ bottom: 2 }}>
              <Gutter.Item>
                <div className={styles.icon}>{icon || <EmptyIcon />}</div>
              </Gutter.Item>
              <Gutter.Item>
                <div className={styles.title} data-cy={EmptySelectors.Title}>
                  {title}
                </div>
              </Gutter.Item>
            </Gutter>
            {!!message && (
              <div className={styles.message} data-cy={EmptySelectors.Message}>
                {capitalizeFirstLetter(message)}
              </div>
            )}
          </Gutter.Item>
          {!!button && (
            <Gutter.Item>
              <Button {...button} />
            </Gutter.Item>
          )}
        </Gutter>
      </div>
    </div>
  );
};
